import { render, staticRenderFns } from "./webSetting.vue?vue&type=template&id=fa184e4e&"
import script from "./webSetting.vue?vue&type=script&lang=js&"
export * from "./webSetting.vue?vue&type=script&lang=js&"
import style0 from "./webSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports